import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "antd";
import ProtectedRoute from "./ProtectedRoute";

const PrivateRoute: React.FC = () => {
  const Home = lazy(() => import("../pages/home/Home"));
  const UIExample = lazy(() => import("../pages/example/ui-example"));

  const WMRList = lazy(() => import("../pages/wmr-list/WMR-List"));

  const layoutStyle: React.CSSProperties = {
    padding: "0 24px 24px",
    backgroundColor: '#fff'
  };

  return (
    <Layout style={layoutStyle}>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<ProtectedRoute component={WMRList} />} />
          <Route path="/workmarket-response"  element={<ProtectedRoute component={WMRList} />}/>  
        </Routes>
      </Suspense>
    </Layout>
  );
};


export default PrivateRoute;